module.exports = __webpack_public_path__ + "img/AndroidTV_X8000E.da2b7e79.png";